function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("path", {
  d: "M17.5,35 C27.1649831,35 35,27.1649831 35,17.5 C35,7.83501688 27.1649831,0 17.5,0 C7.83501688,0 0,7.83501688 0,17.5 C0,27.1649831 7.83501688,35 17.5,35 Z M17.5,33 C8.93958638,33 2,26.0604136 2,17.5 C2,8.93958638 8.93958638,2 17.5,2 C26.0604136,2 33,8.93958638 33,17.5 C33,26.0604136 26.0604136,33 17.5,33 Z"
}), React.createElement("path", {
  d: "M16.5833333,11.7 L16.5833333,24.2406165 C16.5833333,24.7929012 17.0310486,25.2406165 17.5833333,25.2406165 C18.1356181,25.2406165 18.5833333,24.7929012 18.5833333,24.2406165 L18.5833333,11.7 C18.5833333,11.1477153 18.1356181,10.7 17.5833333,10.7 C17.0310486,10.7 16.5833333,11.1477153 16.5833333,11.7 Z",
  transform: "translate(17.583333, 17.970308) rotate(-135.000000) translate(-17.583333, -17.970308) "
}), React.createElement("path", {
  d: "M16.5833333,11.7 L16.5833333,24.2406165 C16.5833333,24.7929012 17.0310486,25.2406165 17.5833333,25.2406165 C18.1356181,25.2406165 18.5833333,24.7929012 18.5833333,24.2406165 L18.5833333,11.7 C18.5833333,11.1477153 18.1356181,10.7 17.5833333,10.7 C17.0310486,10.7 16.5833333,11.1477153 16.5833333,11.7 Z",
  transform: "translate(17.583333, 17.970308) rotate(-45.000000) translate(-17.583333, -17.970308) "
}))));

const SvgEndSessionIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEndSessionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/end-session-icon.401734ca.svg";
export { ForwardRef as ReactComponent };